module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("c7qXX"))).then(() => parcelRequire('f4eak'));